import actions from "./actions";
export default {
  actions,
  state: {
		descriptionsData: {},
		oneDescription: {}
	},
  mutations: {
		descriptionsData(state, payload) {
			state.descriptionsData = payload;
		},
		oneDescription(state, payload) {
			state.oneDescription = { ...payload };
		},
		oneDescriptionTitle(state, res) {
			state.oneDescription.title = res;
		},
		oneDescriptionReleasedAt(state, res) {
			state.oneDescription.released_at = res;
		},
		oneDescriptionContent(state, res) {
			state.oneDescription.content = res;
		}
	},
  getters: {
		descriptionList({ descriptionsData }) {
			return descriptionsData.data;
		},
		paginationInDescriptionList({ descriptionsData }) {
			//remove data key in paginationData
			// eslint-disable-next-line no-unused-vars
			const { data, ...paginationData } = descriptionsData;
			return paginationData;
		},
		oneDescription({ oneDescription }) {
			const initData = {
				id: 1,
				title: "網站說明",
				released_at: "2022-07-22",
				content: "<p>編輯器內文</p>",
				user: {
					id: 2,
					account: "it_admin"
				}
			};
			if (!oneDescription.id) {
				return initData;
			} else {
				return oneDescription;
			}
		},
	}
};
